export const maskedEmail = 'j******@example.com';
